/*
 * File: /src/router/index.js
 * Created Date: Monday May 20th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Monday, 20th May 2019 9:57:54 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
// import Vue from 'vue';
// import Router from 'vue-router';

import store from '../store';
import routes from './routes/main';
import { publicAxios } from '../shared/axiosWrapper';

// Vue.use(Router);

import { createRouter, createWebHistory } from 'vue-router';

// export default routes;
const router = new createRouter({
  history: createWebHistory(),
  // mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {
  // Allow navigating away from an active disposition
  if (store.getters['realtime/getActiveDisposition']) {
    store.dispatch('realtime/modifyActiveDisposition', undefined);
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/getLoginStatus']) {
      next();
      return;
    }
    next('/login');
    return
  } else {
    next();
  }
});

export default router;
